import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCourses } from '../../api'; // Importamos la conexión a la API
import './Navbar.css';
import logo from '../../logo_bullminer.png'; 

const Navbar = () => {
  const [dropdown, setDropdown] = useState(false);
  const [menuCourses, setMenuCourses] = useState([]);

  // Este efecto carga los cursos automáticamente al abrir la página
  useEffect(() => {
    const fetchMenuCourses = async () => {
      try {
        const response = await getCourses();
        // Filtramos para que en el menú solo salgan los cursos de Pago (Premium)
        const paidCourses = response.data.filter(course => course.is_free === false);
        setMenuCourses(paidCourses);
      } catch (error) {
        console.error("Error cargando los cursos del menú", error);
      }
    };
    fetchMenuCourses();
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Logo Bull Miner" className="nav-logo-img" />
          THE BULL MINER
        </Link>
        
        <ul className="nav-menu">
          <li 
            className="nav-item" 
            onMouseEnter={() => setDropdown(true)}
            onMouseLeave={() => setDropdown(false)}
          >
            <span className="nav-links">Aprender <i className="fas fa-caret-down"/></span>
            {dropdown && (
              <ul className="dropdown-menu">
                {/* Renderizamos los cursos dinámicamente desde la base de datos */}
                {menuCourses.length > 0 ? (
                  menuCourses.map(course => (
                    <li key={course.id}>
                      <Link to={`/courses/${course.id}`}>{course.title}</Link>
                    </li>
                  ))
                ) : (
                  <li><span style={{padding: '10px 20px', color: '#8B949E', display: 'block'}}>Cargando...</span></li>
                )}
              </ul>
            )}
          </li>

          <li className="nav-item">
            <Link to="/chronos-geo" className="nav-links">Chronos GEO</Link>
          </li>

          <li className="nav-item">
            <Link to="/historias" className="nav-links">Historias de Éxito</Link>
          </li>
          
          <li className="nav-item">
            <Link to="/equipos" className="nav-links">Consultoría Corporativa</Link>
          </li>

        </ul>
      </div>
    </nav>
  );
};

export default Navbar;